import React, { useMemo } from "react";

import { IUserTravelVisa } from "Bands/types";
import { TeaserProps } from "shared/components";
import { DocumentTeaser } from "./DocumentTeaser";

interface Props extends IUserTravelVisa, TeaserProps {}

export const TravelVisaTeaser: React.FC<Props> = ({ title, documentType, ...rest }) => {
  const teaserTitle = useMemo(
    () => `${documentType} ${title && `(${title})`} `,
    [documentType, title]
  );

  return <DocumentTeaser {...rest} title={teaserTitle} />;
};
